import { render, staticRenderFns } from "./TabCompetitionProposals.vue?vue&type=template&id=79c7de4f&"
import script from "./TabCompetitionProposals.vue?vue&type=script&lang=js&"
export * from "./TabCompetitionProposals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports